// extracted by mini-css-extract-plugin
module.exports = {"signUp":"sign_up-module--sign-up--3ZbJO","extraInfo":"sign_up-module--extra-info--1x43a"};